import styled from 'styled-components'
import { DEVICE } from '../../util/constants'

export const SocialMediaIcon = styled.svg`
  fill: var(--content-background-light);

  :hover {
    cursor: pointer;
    fill: var(--graphic-accent-purple-1);
  }
`

export const ArrowInCircle = styled.svg`
  pointer-events: all;
`

export const NpfLogo = styled.svg`
  width: ${({ forMobileNav }) => (forMobileNav === true ? '165px' : 'unset')};
  display: ${({ forMobileNav }) => (forMobileNav === true ? 'unset' : 'none')};

  @media ${DEVICE.tabletL} {
    display: ${({ forMobileNav }) =>
      forMobileNav === true ? 'none' : 'block'};
  }
`
